import appMethods from '@/common/app-common'
/* 跳转进线页 */
const jumpToMiniProgram = function () {
  let url =
    'pages/image-page/index?url=' +
    encodeURIComponent(
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/54181e8dc464fee8dcec308927d78337.png'
    )
  appMethods.jumpMiniProgram({ path: url })
}
export { jumpToMiniProgram }
